import React from 'react';

const Diary = ({props}) => {
    return (
        <svg
            height={512}
            viewBox="0 0 512 512"
            width={512}
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path d="M88.814 42.89H58.882c-8.284 0-15 6.716-15 15s6.716 15 15 15h29.933v-30zM88.814 141.945H58.882c-8.284 0-15 6.716-15 15s6.716 15 15 15h29.933v-30zM88.814 241H58.882c-8.284 0-15 6.716-15 15s6.716 15 15 15h29.933v-30zM88.814 340.055H58.882c-8.284 0-15 6.716-15 15s6.716 15 15 15h29.933v-30zM88.814 439.11H58.882c-8.284 0-15 6.716-15 15s6.716 15 15 15h29.933v-30z" />
            <path d="M450.468 0H97.355c-4.63 0-8.541 3.911-8.541 8.541v494.918c0 4.63 3.911 8.541 8.541 8.541h353.113c9.732 0 17.65-7.917 17.65-17.65V17.65c0-9.733-7.918-17.65-17.65-17.65zM108.752 469.11H88.817v-30h19.935c8.284 0 15 6.716 15 15s-6.716 15-15 15zm0-99.055H88.817v-30h19.935c8.284 0 15 6.716 15 15s-6.716 15-15 15zm0-99.055H88.817v-30h19.935c8.284 0 15 6.716 15 15s-6.716 15-15 15zm0-99.055H88.817v-30h19.935c8.284 0 15 6.716 15 15s-6.716 15-15 15zm0-99.055H88.817v-30h19.935c8.284 0 15 6.716 15 15s-6.716 15-15 15zM398.82 469.11h-80.461c-8.284 0-15-6.716-15-15s6.716-15 15-15h80.461c8.284 0 15 6.716 15 15s-6.716 15-15 15zm15-319.696c0 8.284-6.716 15-15 15H192.64c-8.284 0-15-6.716-15-15V57.89c0-8.284 6.716-15 15-15h206.18c8.284 0 15 6.716 15 15z" />
        <path d="M207.64 72.89h176.18v61.524H207.64z" />
        </svg>
    )
}

export default Diary;
